import React, { FC } from 'react';
import { Dashboard } from 'models/dashboard';
import { User } from 'models/user';
import { Table as ReactTable, flexRender } from '@tanstack/react-table';
import { Form, Input } from '@flightaware/ui-components';

interface TableProps {
    table: ReactTable<Dashboard> | ReactTable<User>;
    type: 'dashboard' | 'user';
}

const Table: FC<TableProps> = ({ table, type }) => (
    <>
        <Form onSubmit={() => true} submitButton={{ show: false }} resetButton={{ show: false }}>
            <Input
                type="text"
                name="search"
                placeholder={`Search ${type}s...`}
                onChange={(e) => table.setGlobalFilter((e.currentTarget as HTMLInputElement).value)}
            />
        </Form>
        <table className={`table ${type}-table`} data-testid="table">
            <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th
                                key={header.id}
                                onClick={header.column.getToggleSortingHandler()}
                                className={
                                    'table__heading' +
                                    (header.column.getCanSort()
                                        ? ' table__heading--sorted-' + (header.column.getIsSorted() as string)
                                        : '')
                                }
                            >
                                {flexRender(header.column.columnDef.header as string, header.getContext())}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody>
                {table.getRowModel().rows.map((row) => (
                    <tr className={'table__row'} key={row.id}>
                        {row.getVisibleCells().map((cell) => (
                            <td key={cell.id}>{flexRender(cell.column.columnDef.cell as string, cell.getContext())}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
        <div>
            <button onClick={() => table.setPageIndex(0)} disabled={!table.getCanPreviousPage()}>
                {'<<'}
            </button>
            <button onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
                {'<'}
            </button>
            <button onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
                {'>'}
            </button>
            <button onClick={() => table.setPageIndex(table.getPageCount() - 1)} disabled={!table.getCanNextPage()}>
                {'>>'}
            </button>
            {' | '}
            {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
            {' | '}
            <select
                value={table.getState().pagination.pageSize}
                onChange={(e) => {
                    table.setPageSize(Number(e.target.value));
                }}
            >
                {[5, 10, 25, 50].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                        Show {pageSize} per page
                    </option>
                ))}
            </select>
            {' | '}
            {table.getFilteredRowModel().rows.length == table.getPreFilteredRowModel().rows.length
                ? `${table.getPreFilteredRowModel().rows.length} total ${type}s`
                : `showing ${table.getFilteredRowModel().rows.length} of ${
                      table.getPreFilteredRowModel().rows.length
                  } total ${type}s`}
        </div>
    </>
);

export default Table;
